// extracted by mini-css-extract-plugin
module.exports = {"contentInput":"CpfForm_contentInput__Rg393","contentButton":"CpfForm_contentButton__1HrHI","textCpf":"CpfForm_textCpf__2RSkr"};